<template>
  <main-layout>
    <h1 class="title">Ricerca contratti prodotto</h1>
    <b-field horizontal label="Prodotto associato">
      <b-select v-if="productTypes" v-model="selectedProductType">
        <option :value="null"></option>
        <option
          v-for="productType in productTypes.results"
          :key="productType.id"
          :value="productType.id"
        >
          {{ productType.code }}
        </option>
      </b-select>
    </b-field>

    <b-field grouped horizontal style="margin-bottom: 30px">
      <p class="control">
        <button
          class="button is-success"
          style="margin-right: 15px"
          @click="fetch()"
        >
          Cerca
        </button>
        <button class="button" @click="clean()">Pulisci</button>
      </p>
    </b-field>

    <div style="position: relative; min-height: 400px">
      <b-table
        v-if="results"
        striped
        :data="results"
        :loading="loading"
        :total="results.count"
        backend-sorting
        :default-sort="['id', 'desc']"
        @sort="onSort"
      >
        <template slot-scope="props">
          <b-table-column
            field="customer_internal_id"
            label="ID cliente"
            width="40"
            sortable
            numeric
          >
            {{ props.row.customer_internal_id }}
          </b-table-column>

          <b-table-column field="customer_name" label="Cliente" sortable>
            <b>
              <router-link
                :to="{
                  name: 'customers.show',
                  params: { id: props.row.customer }
                }"
              >
                {{ props.row.customer_name }}
              </router-link>
            </b>
          </b-table-column>

          <b-table-column field="product_name" label="Prodotto" sortable>
            {{ props.row.product_name }}
          </b-table-column>

          <b-table-column field="amount" label="Qt." sortable>
            {{ props.row.amount }}
          </b-table-column>

          <b-table-column field="serial" label="Seriale">
            {{ props.row.serial }}
          </b-table-column>
        </template>
        <template slot="footer">
          <download-csv
            class="button is-default"
            :data="results"
            name="data.csv"
            delimiter=";"
          >
            <b-icon icon="table"></b-icon>
            <span>CSV</span>
          </download-csv>
        </template>
      </b-table>
      <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"

import MainLayout from "@/layouts/Main"
import ProductContractProxy from "@/proxies/ProductContractProxy"

export default {
  name: "ProductContractsIndex",
  components: {
    MainLayout
  },
  data() {
    return {
      loading: false,
      results: null,
      sortField: "id",
      sortOrder: "desc",
      selectedProductType: null
    }
  },
  computed: {
    productTypes: get("productTypes/productTypes")
  },
  mounted() {
    this.fetchProductTypes()
  },
  methods: {
    fetchProductTypes: call("productTypes/all"),
    async fetch() {
      this.loading = true
      let params = {
        ordering: `${this.sortOrder == "desc" ? "-" : ""}${this.sortField}`
      }

      if (this.selectedProductType) {
        params.product = this.selectedProductType
      }

      this.results = await new ProductContractProxy(params).all()

      if (this.results.length === 0) {
        this.results = null
        this.$toast.open({
          message: "Nessun risultato trovato",
          type: "is-warning"
        })
      }
      this.loading = false
    },
    clean() {
      this.selectedProductType = null
      this.results = null
    },
    fixDate(date) {
      return this.$moment(date).format("YYYY-MM-DD")
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetch()
    }
  }
}
</script>
